import { useEffect } from "react"
import { useTaskSortStore } from "@/stores/useTaskSortStore"
import { useTaskList } from "@/hooks"
import { IAccount } from "@/types"
import { TaskSortType } from "@/components/Task/types"

export const useSortedTaskList = (account: IAccount, tasklistId: string, sortType: TaskSortType) => {
  const { data, isPending } = useTaskList(account, tasklistId)
  const { getTasksOrders, setTasksOrders, sortTasksBySortType } = useTaskSortStore()

  useEffect(() => {
    if (data) {
      setTasksOrders(account.id, tasklistId, data.filter(task => task.status === "needsAction"))
      sortTasksBySortType(account.id, tasklistId, sortType)
    }
  }, [data, sortType, account.id, tasklistId, setTasksOrders, sortTasksBySortType])

  return {
    tasks: getTasksOrders(account.id, tasklistId),
    isPending,
  }
}